export const formFields = {
  entries: [
    { name: 'collection', label: 'Collection' },
    { name: 'sourceNumber', label: 'Source Number' },
    { name: 'location', label: 'Location' },
    { name: 'title', label: 'Title' },
    { name: 'composer', label: 'Composer' },
    { name: 'vocalPart', label: 'Vocal Part/s' },
    { name: 'key', label: 'Key/s' },
    { name: 'melodicIncipit', label: 'Melodic Incipit' },
    { name: 'textIncipit', label: 'Text Incipit' },
    { name: 'isSecular', label: 'Secular' },
    { name: 'notes', label: 'Notes' },
    { name: 'pageAdjuster', label: 'Page Adjuster' },
  ],

  sources: [
    { name: 'collection', label: 'Collection' },
    { name: 'sourceNumber', label: 'Source Number' },
    { name: 'callNumber', label: 'Call Number' },
    { name: 'author', label: 'Author' },
    { name: 'title', label: 'Title' },
    { name: 'description', label: 'Description' },
    { name: 'inscription', label: 'Inscriptions' },
    { name: 'msEntries', label: 'MS. Music' },
  ],

  collections: [
    { name: 'collection', label: 'Collection' },
    { name: 'description', label: 'Description' },
  ],
};
